import React from 'react'

/**
 * Shared building blocks for the "Add filter" popover menu — a labelled section
 * and a clickable field row. Used by both the builder sidebar (ReportSetup) and
 * the view-mode quick-filter bar (QuickFilterBar) so the menu reads identically
 * wherever filters are added.
 */

/** Section heading inside the "Add filter" menu. */
export function MenuSection({
  label,
  children,
}: {
  label: string
  children: React.ReactNode
}) {
  return (
    <div className="mb-1 last:mb-0">
      <span className="block px-2 pb-0.5 pt-1 text-xxs font-semibold uppercase tracking-wide text-fg-secondary">
        {label}
      </span>
      {children}
    </div>
  )
}

/** Clickable field row inside the "Add filter" menu. */
export const MenuItem = React.forwardRef<
  HTMLButtonElement,
  { label: string; onClick: () => void }
>(({ label, onClick, ...props }, ref) => (
  <button
    ref={ref}
    type="button"
    onClick={onClick}
    className="flex w-full rounded px-2 py-1.5 text-left text-sm text-fg hover:bg-surface-hover"
    {...props}
  >
    {label}
  </button>
))
MenuItem.displayName = 'MenuItem'
